import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import Toolbar from 'material-ui-next/Toolbar'
import IconButton from 'material-ui-next/IconButton'
import withStyles from 'material-ui-next/styles/withStyles'
import Divider from 'material-ui-next/Divider'
import Icon from 'material-ui-next/Icon'
import Menu, { MenuItem } from 'material-ui-next/Menu'
import MenuDivider from './MenuDivider'
import List, {
  ListItem,
  ListItemIcon,
  ListItemText,
} from 'material-ui-next/List'
import Drawer from 'material-ui-next/Drawer'
import MainToolbarTitleMobile from './MainToolbarTitleMobile'
import { logout } from '../../actions'

const styles = theme => ({
  drawer: {
    zIndex: 1000000,
  },
  right0: {
    right: 0,
  },
  toolbar: {
    backgroundColor: theme.swapick.colors.positive,
    color: theme.swapick.colors.light,
    minHeight: `${theme.swapick.dimensions.toolbar}px`,
    justifyContent: 'space-between',
    transition: '0.5s',
    alignItems: 'flex-start',
  },
  linkLogo: {
    alignSelf: 'center',
  },
  logo: {
    height: '24px',
    paddingRight: 16,
  },
  title: {
    alignSelf: 'center',
  },
  primaryBackground: {
    backgroundColor: theme.swapick.colors.positive,
    height: theme.swapick.dimensions.toolbar,
    '&:hover': {
      backgroundColor: theme.swapick.colors.darkpositive,
    },
  },
  iconWhite: {
    color: theme.swapick.colors.white,
    '&:hover': {
      color: theme.swapick.colors.light,
    },
    '&:visited': {
      color: theme.swapick.colors.white,
    },
    '&:active': {
      color: theme.swapick.colors.light,
    },
  },
  primaryText: {
    color: theme.swapick.colors.positive,
    '&:hover': {
      color: theme.swapick.colors.energized,
    },
  },
})

class MainToolbarMobile extends PureComponent {
  state = {
    drawerOpen: false,
  }

  openDrawer = () => this.setState({ drawerOpen: true })

  closeDrawer = () => this.setState({ drawerOpen: false })

  render() {
    const { classes, logout, user } = this.props
    return (
      <Toolbar className={classes.toolbar} disableGutters={true}>
        <IconButton onClick={this.openDrawer}>
          <Icon className={classes.iconWhite}>menu</Icon>
        </IconButton>
        <MainToolbarTitleMobile />
        <Link to="/" className={`${classes.linkLogo}`}>
          <img
            alt="Swapick Logo"
            src="/img/logosmall.png"
            className={classes.logo}
          />
        </Link>
        <Drawer
          classes={{ modal: classes.drawer, paper: classes.right0 }}
          onClose={this.closeDrawer}
          open={this.state.drawerOpen}>
          {user && (
            <List disablePadding>
              <ListItem
                className={classes.primaryBackground}
                button
                onClick={this.closeDrawer}>
                <ListItemIcon>
                  <Icon className={classes.iconWhite}>
                    {this.state.drawerOpen ? 'close' : 'menu'}
                  </Icon>
                </ListItemIcon>
              </ListItem>
              <Link to="/profile">
                <ListItem button divider onClick={this.closeDrawer}>
                  <ListItemIcon>
                    <Icon>account_circle</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={user ? user.username : ''}
                    classes={{ text: classes.primaryText }}
                  />
                </ListItem>
              </Link>
              <Link to="/add">
                <ListItem button divider onClick={this.closeDrawer}>
                  <ListItemIcon>
                    <Icon>note_add</Icon>
                  </ListItemIcon>
                  <ListItemText primary="Nuovo oggetto" />
                </ListItem>
              </Link>
              <Link to="/me/items/owned">
                <ListItem button onClick={this.closeDrawer}>
                  <ListItemIcon>
                    <Icon>playlist_add_check</Icon>
                  </ListItemIcon>
                  <ListItemText primary="Lista possiedo" />
                </ListItem>
              </Link>
              <Link to="/me/items/wanted">
                <ListItem button onClick={this.closeDrawer}>
                  <ListItemIcon>
                    <Icon>playlist_add_check</Icon>
                  </ListItemIcon>
                  <ListItemText primary="Lista Voglio" />
                </ListItem>
              </Link>
              <Link to="/me/items/can-get">
                <ListItem button divider onClick={this.closeDrawer}>
                  <ListItemIcon>
                    <Icon>playlist_play</Icon>
                  </ListItemIcon>
                  <ListItemText primary="Posso avere" />
                </ListItem>
              </Link>
              <List disablePadding>
                <Link to="/me/swaps">
                  <ListItem button onClick={this.closeDrawer}>
                    <ListItemIcon>
                      <Icon>autorenew</Icon>
                    </ListItemIcon>
                    <ListItemText primary="Proposte" />
                  </ListItem>
                </Link>
                <Link to="https://about.swapick.com/come-funziona" target="_blank">
                  <ListItem button onClick={this.closeDrawer}>
                    <ListItemIcon>
                      <Icon>monetization_on</Icon>
                    </ListItemIcon>
                    <ListItemText primary="eCoin" />
                  </ListItem>
                </Link>
                <Link to="/messages">
                  <ListItem button divider onClick={this.closeDrawer}>
                    <ListItemIcon>
                      <Icon>message</Icon>
                    </ListItemIcon>
                    <ListItemText primary="Messaggi" />
                  </ListItem>
                </Link>
              </List>
              <Link to="https://about.swapick.com/come-funziona" target="_blank">
                <ListItem button divider onClick={this.closeDrawer}>
                  <ListItemIcon>
                    <Icon>help</Icon>
                  </ListItemIcon>
                  <ListItemText primary="Come Funziona" />
                </ListItem>
              </Link>
              <ListItem
                button
                divider
                onClick={() => {
                  this.closeDrawer()
                  logout()
                }}>
                <ListItemIcon>
                  <Icon>exit_to_app</Icon>
                </ListItemIcon>
                <ListItemText primary="Logout" />
              </ListItem>
            </List>
          )}
          {!user && (
            <List disablePadding>
              <ListItem
                className={classes.primaryBackground}
                button
                onClick={this.closeDrawer}>
                <ListItemIcon>
                  <Icon className={classes.iconWhite}>menu</Icon>
                </ListItemIcon>
              </ListItem>
              <Link to="/login">
                <ListItem button divider onClick={this.closeDrawer}>
                  <ListItemIcon>
                    <Icon>subdirectory_arrow_right</Icon>
                  </ListItemIcon>
                  <ListItemText primary={'login'} />
                </ListItem>
              </Link>
              <Link to="https://about.swapick.com/come-funziona" target="_blank">
                <ListItem button divider onClick={this.closeDrawer}>
                  <ListItemIcon>
                    <Icon>help</Icon>
                  </ListItemIcon>
                  <ListItemText primary="Come Funziona" />
                </ListItem>
              </Link>
            </List>
          )}
        </Drawer>
      </Toolbar>
    )
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
})

export default withRouter(
  withStyles(styles)(
    connect(mapStateToProps, {
      logout,
    })(MainToolbarMobile)
  )
)



// WEBPACK FOOTER //
// ./src/common/TopBar/MainToolbarMobile.js